//jsxhook

import { StandardXAxisSpace } from "@sixty-six-north/ui-system"
import { Box } from "theme-ui"
import React from "react"
// useful layout wrapper to indent the checkout form on desktop and inline on mobile.
export const CheckoutStepLayout: React.FC<{ children?: React.ReactNode }> = ({
  children
}) => {
  return (
    <Box
      sx={{
        px: [24, null, 48, 48, 48, StandardXAxisSpace],
        maxWidth: ["100%", null, null, "80%"],
        mx: "auto",
        my: 40
      }}
    >
      {children}
    </Box>
  )
}
